module.exports = __webpack_public_path__ + "img/file-invoice.f864f7ac.svg";